<template>
  <div class="floatingDrawerButton" >
    <v-btn
      v-if="mx_needsDrawer"
      :color="appBarColor"
      @click="$emit('onSelectedFloatingButton')"
      fab
    >
      <v-icon> {{ openDrawerIcon }} </v-icon>
    </v-btn>
  </div>
</template>

<script>
import common from '../../../mixins/common';
  export default {
    name: 'FloatingNavigationButton',
    mixins: [common],
    props: {
      openDrawerIcon: {
        type: String,
        default: 'mdi-menu'
      },
    },
  };
</script>

<style scoped>
  .floatingDrawerButton {
    padding: 1rem;
    position: absolute;
    bottom:0; right:0;
  }
</style>